import { Secondary } from "../secondary/Secondary.component";
import { Menu } from "../menu/Menu.component";
import { Mobile } from "../mobile/Mobile.component";
import {Hero} from '../hero/Hero.component';
import apiData from './staticData.json';
import Bg from './families-and-friends-header.a69e92c1.jpg'
import { StyledDiv } from "./Static.styles";

export const Static = () => {
    return <header>
        <Mobile menuData={apiData.Mobile} secondaryData={apiData.SecondaryMenu} searchData={apiData.SearchUrl} />
        <StyledDiv background={Bg} id="hero-banner">
            <Secondary linksData={apiData.SecondaryMenu} searchData={apiData.SearchUrl} />
            <Menu menuData={apiData.Menu} />
            <Hero />
        </StyledDiv>
    </header>
}